var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#0F1118",
    opacity: 0.8,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10,28 L9.85073766,27.9945143 C8.81587779,27.9181651 8,27.0543618 8,26 L8,26 L8,19 L10,19 L10,25.999 L24,26 L28,25.999 L28,15 L27.999,11 L10,11.001 L10,19 L8,19 L8,11 C8,9.9456382 8.81587779,9.08183488 9.85073766,9.00548574 L10,9 L28,9 C29.0543618,9 29.9181651,9.81587779 29.9945143,10.8507377 L30,11 L30,26 C30,27.0543618 29.1841222,27.9181651 28.1492623,27.9945143 L28,28 L10,28 Z M17,13 C17.5522847,13 18,13.4477153 18,14 C18,14.5522847 17.5522847,15 17,15 L17,15 L15.4151068,15 L19.4142136,19 C19.8047379,19.3905243 19.8047379,20.0236893 19.4142136,20.4142136 C19.0236893,20.8047379 18.3905243,20.8047379 18,20.4142136 L18,20.4142136 L14.0001068,16.413 L14,18 C14,18.5522847 13.5522847,19 13,19 C12.4477153,19 12,18.5522847 12,18 L12,18 L12,14 C12,13.4477153 12.4477153,13 13,13 L13,13 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    x: 21,
    y: 21,
    fill: "#FFF",
    rx: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.cce4053056c16dc017fba44d6ff4dda0.svg";
export { ForwardRef as ReactComponent };